import { render } from "./CompanyDetails.vue?vue&type=template&id=033966bc&scoped=true"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"

import "./CompanyDetails.vue?vue&type=style&index=0&id=033966bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033966bc"]])

export default __exports__